import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import {
  EnrollMarketingFlowContactPayload,
  MarketingFlowEnrollment
} from "../../marketing.types";
import { requestEnrollMarketingFlowContact } from "./enrollMarketingFlowContact.request";

const useEnrollMarketingFlowContact = (
  options?: MutationOptions<
    MarketingFlowEnrollment,
    ApiServiceError<ApiError>,
    EnrollMarketingFlowContactPayload
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: requestEnrollMarketingFlowContact,
    ...options,
    onSuccess: (data, variables, ctx) => {
      void queryClient.invalidateQueries({ queryKey: ["marketing", "flows"] });
      options?.onSuccess?.(data, variables, ctx);
    }
  });
};

export default useEnrollMarketingFlowContact;
